<template>
  <div v-if="totalVehicles" :id="componentId" dir="ltr" class="similar-vehicles">
    <h2 class="similar-vehicles__title wb-type-heading-xl" v-text="title"></h2>
    <p v-if="totalVehicles > 1" class="similar-vehicles__description" v-html="description"></p>
    <horizontal-slider class="similar-vehicles__slider" :vehicles="vehicles" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

export default defineComponent({ name: 'SimilarVehicles' });
</script>

<script lang="ts" setup>
import { PropType, ref, toRefs, watch } from 'vue';
import HorizontalSlider from './horizontal-slider/HorizontalSlider.vue';
import { useI18n } from '../../composables/i18n.composable';
import Vehicle from '../../models/vehicle.model';

const { t } = useI18n();
const props = defineProps({
  componentId: {
    type: String,
    default: 'similar-vehicles-wrapper',
  },
  vehicles: {
    type: Array as PropType<Vehicle[]>,
    default: () => [],
  },
});

const { vehicles } = toRefs(props);
const totalVehicles = computed(() => vehicles.value.length);
const title = t('dcp.error.outOfStockError.similarVehicles.slider.title');
const description = ref('');

watch(
  vehicles,
  () => {
    description.value = t('dcp.error.outOfStockError.similarVehicles.slider.description', {
      totalVehicles: `<strong>${totalVehicles.value}</strong>`,
      interpolation: {
        prefix: '{',
        suffix: '}',
        escapeValue: false,
      },
    });
  },
  { immediate: true },
);
</script>

<style lang="scss">
.similar-vehicles {
  @include wb-content-width;

  &__title {
    @include wb-spacing('margin-top', l);
    @include wb-spacing('margin-bottom', m);
  }

  &__description {
    margin: 0;
    @include wb-spacing('margin-bottom', m);
  }

  &__slider {
    @include wb-spacing('padding-bottom', l);
  }
}
</style>
